export const isLocal = () => {
  return location.host.includes('localhost')
}
